import React, { FC, useContext } from "react";
import classNames from "classnames";
import { useIntl, defineMessages } from "react-intl";
import { Button } from "@natera/form";
import { Svg } from "@natera/material/lib/svg";
import GoogleLogoSvg from "@assets/svg/google-logo.svg";
import AppleLogoSvg from "@assets/svg/apple-logo.svg";
import { CredentialsIdentityProvider } from "@natera/platform/lib/service/session/session";
import { IDP_TYPE } from "@app/service/user";
import { ConfigContext } from "@app/provider";

import "./authenticationButton.scss";

const messages = defineMessages({
  signInWithAuthenticationProvidersContinueWithGoogle: {
    id: "signInWithAuthenticationProvidersContinueWithGoogle",
    defaultMessage: "Continue with Google",
  },
  signInWithAuthenticationProvidersContinueWithApple: {
    id: "signInWithAuthenticationProvidersContinueWithApple",
    defaultMessage: "Continue with Apple",
  },
});

interface AuthenticationButtonProps {
  onClick: (
    credentials: CredentialsIdentityProvider,
    idp: IDP_TYPE
  ) => Promise<void>;
  idp: IDP_TYPE;
}

export const AuthenticationButton: FC<AuthenticationButtonProps> = ({
  idp,
  onClick,
}) => {
  const intl = useIntl();
  const { config } = useContext(ConfigContext);

  const identityProvider =
    idp === IDP_TYPE.GOOGLE
      ? config.okta.identityProvider.googleIdp
      : config.okta.identityProvider.appleIdp;

  return (
    <Button
      className={classNames("authentication-btn", {
        "authentication-btn__apple_ipd": idp === IDP_TYPE.APPLE,
      })}
      outlined={true}
      onClick={() =>
        onClick(
          {
            clientId: config.okta.clientId,
            idp: identityProvider,
            issuer: config.okta.issuer,
            scope: config.okta.scopes,
          },
          idp
        )
      }
    >
      <Svg
        className={classNames("authentication-btn__icon", {
          "authentication-btn__icon-google": idp === IDP_TYPE.GOOGLE,
        })}
        content={idp === IDP_TYPE.GOOGLE ? GoogleLogoSvg : AppleLogoSvg}
      />
      {idp === IDP_TYPE.GOOGLE
        ? intl.formatMessage(
            messages.signInWithAuthenticationProvidersContinueWithGoogle
          )
        : intl.formatMessage(
            messages.signInWithAuthenticationProvidersContinueWithApple
          )}
    </Button>
  );
};
